<template>
    <div class="getUs">
        <div class="banner"></div>
        <ul class="gongsiZhi">
            <li class="li1" @click="clickP('南京公司','118.741459','31.988395')">
                <p class="name">南京：南京壹宝通信息技术有限公司</p>
                <p class="dizhi">地址：南京市建邺区国家广告产业园5栋706室</p>
                <p class="dianhua">服务热线：18205080131 </p>
            </li>
            <li class="li2" @click="clickP('徐州分公司','117.209707','34.273777')">
                <p class="name">徐州：徐州分公司</p>
                <p class="dizhi">地址：徐州市鼓楼区和信广场A座1008室</p>
                <p class="dianhua">服务热线：18205080131 </p>
            </li>
            <li class="li3" @click="clickP('苏州分公司','120.741478','31.27128')">
                <p class="name">苏州：苏州分公司</p>
                <p class="dizhi">地址：苏州工业园区苏州创意产业园5期6栋921室</p>
                <p class="dianhua">服务热线：18205080131 </p>
            </li>
        </ul>
<!--        <p class="p-difang">{{pName}}</p>-->
        <div class="container" id="container">

        </div>
        <div class="zhong"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pName:"南京公司",
            xP:"118.741459",
            yP:"31.988395"
        }
    },
   mounted () {
       // this.clickP('南京公司','118.741459','31.988395')
   },
   methods: {
        clickP(p,x,y){
            this.pName = p
            var map = new BMap.Map("container", {
                coordsType: 5 // coordsType指定输入输出的坐标类型，3为gcj02坐标，5为bd0ll坐标，默认为5。
                            // 指定完成后API将以指定的坐标类型处理您传入的坐标
            });          // 创建地图实例
            var point = new BMap.Point(Number(x),Number(y));  // 创建点坐标
            map.centerAndZoom(point, 17);                 // 初始化地图，设置中心点坐标和地图级别
            map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
            map.addControl(new BMap.NavigationControl());
            map.addControl(new BMap.ScaleControl());
            map.addControl(new BMap.OverviewMapControl());
            var point = new BMap.Point(Number(x),Number(y));

            var marker = new BMap.Marker(point);
            map.addOverlay(marker);
        }
   }
}
</script>
<style lang='less' scoped>
.getUs{
    width: 100%;
    text-align: left;
    .banner{
        width:100%;
        height: 450px;
        background-image: url(./banner-pc-img/lxwm_1920337.5@1x-tuya.png);
        background-size: 100%;
        background-repeat: no-repeat;
    }
    .gongsiZhi{
        width: 80%;
        margin:120px auto;
        position: relative;
        display: flex;
        justify-content: space-around;
        li{
            width: 30%;
            background-color: #fff;
            position: absolute;
            top: 0px;
            box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
            border-radius: 10px;
            padding: 40px;
            padding-top: 35px;
            box-sizing: border-box;
            transition: all 0.3s linear;
            cursor: pointer;
            .name{
                color: #000;
                font-size: 24px;
                font-weight: bold;
                letter-spacing: 1px;
            }
            .dizhi,.dianhua,.youxiang{
                margin-top: 30px;
                font-size: 19px;
                letter-spacing: 1px;
                padding: 2px;
            }
            .dianhua{
                margin-top: 10px;
            }
        }
        .li1{
            left: 20px;
        }
        .li2{
            left: 700px;
        }

        .li3{
            left: 1380px;
        //    box-shadow:none;
        }
        li:hover{
            top: -7px;
        }
    }
    .p-difang{
        width: 78%;
        height: 40px;
        margin: 0 auto;
        margin-top: 280px;
    }
    .container{
        width: 78%;
        margin: 50px auto 20px;
        height: 150px;
        margin-top: 30px;
    }
    .zhong{
        width: 80%;
        margin:0 auto;
        height: 30px;
        text-align: right;
    }

}
</style>
